<template>
    <div class="dashboard-container">
        <!-- 新增：添加组件按钮 -->
        <div class="add-component-btn">
            <el-button type="primary" icon="el-icon-plus" @click="openComponentModal('add')">
                添加组件
            </el-button>
        </div>

        <!-- 主内容区域 -->
        <div class="main-content">
            <!-- 动态渲染组件：适配后端返回的字段，增加编辑/删除按钮 + 拖拽调整宽高 -->
            <div v-for="(item, index) in activeComponents" :key="item.id || index" class="component-card" :style="{
                width: `${item.width}px`,
                height: `${item.height}px`,
                margin: '0px',
                display: 'inline-block',
                verticalAlign: 'top',
                position: 'relative'
            }">
                <!-- 动态组件 -->
                <component :is="item.name" v-bind="item.props" v-on="item.events" :style="{
                    width: '100%',
                    height: '100%'
                }" />
                <!-- 操作按钮组：悬浮显示 -->
                <div class="component-actions">
                    <el-button type="text" icon="el-icon-edit" class="edit-btn"
                        @click.stop="openComponentModal('edit', item)" style="color: #409eff;">
                        编辑
                    </el-button>
                    <el-button type="text" icon="el-icon-delete" class="delete-btn"
                        @click.stop="handledeleteHomePageModels(item.id)" style="color: #f56c6c;">
                        删除
                    </el-button>
                </div>
                <!-- 新增：拖拽调整手柄（右下角） -->
                <div class="resize-handle" @mousedown="(e) => startResize(e, item)"></div>
            </div>
        </div>

        <!-- 图片预览弹窗：添加 append-to-body 和 z-index 样式 -->
        <ImagePreview :visible="previewVisible" :image-url="previewImageUrl" :title="previewTitle"
            @close="previewVisible = false" append-to-body style="z-index: 2000 !important;" />

        <!-- 维保提醒弹窗：添加 append-to-body 和 z-index 样式 -->
        <MaintenanceWarn :visible="maintenanceWarnVisible" :expired-device-list="expiredDeviceList"
            :room-list="roomList" @close="maintenanceWarnVisible = false" @goto-maintenance="handleGotoMaintenance"
            append-to-body :z-index="2000" />

        <!-- 合并：新增/编辑组件共用弹窗 -->
        <el-dialog :title="modalTitle" :visible.sync="componentModalVisible" width="600px" @close="resetComponentForm"
            append-to-body :z-index="2001" class="component-modal-dialog">
            <!-- 弹窗内容区设置固定高度，超出滚动 -->
            <div style="height: 220px; overflow-y: auto; padding: 10px 0;">
                <el-form :model="componentForm" label-width="140px" :rules="componentFormRules" ref="componentFormRef">
                    <el-form-item label="选择组件" prop="componentName">
                        <el-select v-model="componentForm.componentName" placeholder="请选择组件" style="width: 100%;">
                            <el-option v-for="option in componentOptions" :key="option.value" :label="option.label"
                                :value="option.value" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="组件宽度(px)" prop="width">
                        <el-input-number v-model="componentForm.width" :min="200" :max="1200" :step="10"
                            style="width: 100%;" />
                    </el-form-item>
                    <el-form-item label="组件高度(px)" prop="height">
                        <el-input-number v-model="componentForm.height" :min="200" :max="800" :step="10"
                            style="width: 100%;" />
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="componentModalVisible = false">取消</el-button>
                <el-button type="primary" @click="submitComponentForm">{{ modalSubmitText }}</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
// 引入子组件（代码不变，省略）
import CheckinOverview from '@/components/dashboard/CheckinOverview.vue';
import DeviceStatusChart from '@/components/dashboard/DeviceStatusChart.vue';
import CheckinStatusChart from '@/components/dashboard/CheckinStatusChart.vue';
import DeviceManagement from '@/components/dashboard/DeviceManagement.vue';
import TodayMenu from '@/components/dashboard/TodayMenu.vue';
import ImagePreview from '@/components/dashboard/ImagePreview.vue';
import MaintenanceWarn from '@/components/dashboard/MaintenanceWarn.vue';
import MaintenanceRecord from '@/components/dashboard/MaintenanceRecord.vue';
import EquipmentAccessories from '@/components/dashboard/EquipmentAccessories.vue';
import PoliceRecord from '@/components/dashboard/PoliceRecord.vue';
import StorageLocation from '@/components/dashboard/StorageLocation.vue';
import OutboundPlan from '@/components/dashboard/OutboundPlan.vue';
import InventoryRecord from '@/components/dashboard/InventoryRecord.vue';
import IngredientTemplate from '@/components/dashboard/IngredientTemplate.vue';
import CustomerManagement from '@/components/dashboard/CustomerManagement.vue';
import SupplierManagement from '@/components/dashboard/SupplierManagement.vue';
import ProcurementList from '@/components/dashboard/ProcurementList.vue';
import PurchaseRecord from '@/components/dashboard/PurchaseRecord.vue';
import MaterialRequirements from '@/components/dashboard/MaterialRequirements.vue';
import PesticideResidue from '../components/dashboard/PesticideResidue.vue';
import RetainedSample from '@/components/dashboard/RetainedSample.vue';
import SmartSterilizingCabinet from '@/components/dashboard/SmartSterilizingCabinet.vue';
// 引入API
import { getCheckData } from "@/api/morningCheck";
import { getDeviceList } from "@/api/device";
import { getDevices, getClockIn, addHomePageModels, getHomePageModels, deleteHomePageModels, editHomePageModels } from "@/api/index";
import { getRoomList } from "@/api/function";

export default {
    components: {
        CheckinOverview,
        DeviceStatusChart,
        CheckinStatusChart,
        DeviceManagement,
        TodayMenu,
        ImagePreview,
        EquipmentAccessories,
        OutboundPlan,
        MaintenanceWarn,
        MaintenanceRecord,
        PoliceRecord,
        StorageLocation,
        InventoryRecord, IngredientTemplate, CustomerManagement, SupplierManagement,
        ProcurementList, PurchaseRecord,
        MaterialRequirements,
        PesticideResidue, RetainedSample, SmartSterilizingCabinet
    },
    data() {
        return {
            // 饼图数据
            deviceChartData: [{ value: 0, name: '在线' }, { value: 0, name: '离线' }],
            checkinChartData: [{ value: 0, name: '已打卡' }, { value: 0, name: '未打卡' }],
            // 今日菜品列表数据
            todayMenuList: [
                { id: 1, name: '红烧肉', category: '热菜', taste: '咸鲜', image: 'https://img.alicdn.com/imgextra/i4/2200569331264/O1CN014t35k523p35823p35_!!0-saturn_solar.jpg_468x468q75.jpg_.webp' },
                { id: 2, name: '清蒸鲈鱼', category: '热菜', taste: '清淡', image: 'https://img.alicdn.com/imgextra/i4/2200569331264/O1CN014t35k523p35823p35_!!0-saturn_solar.jpg_468x468q75.jpg_.webp' },
                { id: 3, name: '麻婆豆腐', category: '热菜', taste: '麻辣', image: 'https://img.alicdn.com/imgextra/i4/2200569331264/O1CN014t35k523p35823p35_!!0-saturn_solar.jpg_468x468q75.jpg_.webp' },
                { id: 4, name: '拍黄瓜', category: '凉菜', taste: '酸辣', image: 'https://img.alicdn.com/imgextra/i4/2200569331264/O1CN014t35k523p35823p35_!!0-saturn_solar.jpg_468x468q75.jpg_.webp' },
                { id: 5, name: '西红柿鸡蛋汤', category: '汤品', taste: '酸甜', image: 'https://img.alicdn.com/imgextra/i4/2200569331264/O1CN014t35k523p35823p35_!!0-saturn_solar.jpg_468x468q75.jpg_.webp' },
            ],
            // 功能间列表
            roomList: [],
            // 打卡和设备列表数据
            checkinOverviewList: [],
            deviceList: [],
            // 弹窗相关
            previewVisible: false,
            previewImageUrl: "",
            previewTitle: "",
            maintenanceWarnVisible: false,
            expiredDeviceList: [],
            hasWarned: false,

            // 合并：组件管理相关
            componentModalVisible: false, // 新增/编辑共用弹窗显示状态
            modalType: 'add', // 弹窗类型：add-新增，edit-编辑
            editComponentId: '', // 正在编辑的组件ID
            activeComponents: [], // 已激活显示的组件列表

            // 合并：新增/编辑共用表单
            componentForm: {
                componentName: '', // 选中的组件名称
                width: 400, // 默认宽度
                height: 400 // 默认高度
            },

            // 合并：表单校验规则（新增/编辑共用）
            componentFormRules: {
                componentName: [
                    { required: true, message: '请选择组件', trigger: 'change' }
                ],
                width: [
                    { required: true, message: '请输入组件宽度', trigger: 'blur' },
                    { type: 'number', min: 200, max: 1200, message: '宽度需在200-1200px之间', trigger: 'blur' }
                ],
                height: [
                    { required: true, message: '请输入组件高度', trigger: 'blur' },
                    { type: 'number', min: 200, max: 800, message: '高度需在200-800px之间', trigger: 'blur' }
                ]
            },

            // 组件选项列表
            componentOptions: [
                { label: '打卡概览', value: 'CheckinOverview' },
                { label: '设备状态图表', value: 'DeviceStatusChart' },
                { label: '打卡状态图表', value: 'CheckinStatusChart' },
                { label: '设备管理', value: 'DeviceManagement' },
                { label: '今日菜品', value: 'TodayMenu' },
                { label: '维保记录', value: 'MaintenanceRecord' },
                { label: '设备配件', value: 'EquipmentAccessories' },
                { label: '报警记录', value: 'PoliceRecord' },
                { label: '货位管理', value: 'StorageLocation' },
                { label: '出入库计划', value: 'OutboundPlan' },
                { label: '出入库记录', value: 'InventoryRecord' },
                { label: '食材模版', value: 'IngredientTemplate' },
                { label: '客户管理', value: 'CustomerManagement' },
                { label: '供应商管理', value: 'SupplierManagement' },
                { label: '采购清单', value: 'ProcurementList' },
                { label: '采购记录', value: 'PurchaseRecord' },
                { label: '需求物料', value: 'MaterialRequirements' },
                { label: '农残检测', value: 'PesticideResidue' },
                { label: '留样记录', value: 'RetainedSample' },
                { label: '智能消毒柜', value: 'SmartSterilizingCabinet' }
            ],
            // 新增：组件名称与组件路径的映射（根据实际路径调整）
            componentPathMap: {
                CheckinOverview: '@/components/dashboard/CheckinOverview.vue',
                DeviceStatusChart: '@/components/dashboard/DeviceStatusChart.vue',
                CheckinStatusChart: '@/components/dashboard/CheckinStatusChart.vue',
                DeviceManagement: '@/components/dashboard/DeviceManagement.vue',
                TodayMenu: '@/components/dashboard/TodayMenu.vue',
                MaintenanceRecord: '@/components/dashboard/MaintenanceRecord.vue',
                EquipmentAccessories: '@/components/dashboard/EquipmentAccessories.vue',
                PoliceRecord: '@/components/dashboard/PoliceRecord.vue',
                StorageLocation: '@/components/dashboard/StorageLocation.vue',
                OutboundPlan: '@/components/dashboard/OutboundPlan.vue',
                InventoryRecord: '@/components/dashboard/InventoryRecord.vue',
                IngredientTemplate: '@/components/dashboard/IngredientTemplate.vue',
                CustomerManagement: '@/components/dashboard/CustomerManagement.vue'
            },
            // 新增：拖拽相关状态
            resizingComponent: null, // 当前正在调整的组件
            startX: 0, // 拖拽起始X坐标
            startY: 0, // 拖拽起始Y坐标
            startWidth: 0, // 拖拽起始宽度
            startHeight: 0 // 拖拽起始高度
        };
    },
    computed: {
        // 动态计算弹窗标题
        modalTitle() {
            return this.modalType === 'add' ? '添加组件' : '编辑组件';
        },
        // 动态计算提交按钮文字
        modalSubmitText() {
            return this.modalType === 'add' ? '确定添加' : '确定修改';
        }
    },
    created() {
        this.fetchAllData();
        this.getList();
    },
    mounted() {
        // 新增：监听鼠标移动和松开事件（全局）
        document.addEventListener('mousemove', this.handleMouseMove);
        document.addEventListener('mouseup', this.stopResize);
    },
    beforeDestroy() {
        // 新增：移除全局事件监听，避免内存泄漏
        document.removeEventListener('mousemove', this.handleMouseMove);
        document.removeEventListener('mouseup', this.stopResize);
    },
    methods: {
        // 新增：开始拖拽调整宽高
        startResize(e, component) {
            // 阻止事件冒泡，避免触发其他操作
            e.stopPropagation();
            // 记录拖拽起始状态
            this.resizingComponent = component;
            this.startX = e.clientX;
            this.startY = e.clientY;
            this.startWidth = component.width;
            this.startHeight = component.height;
            // 修改鼠标样式
            document.body.style.cursor = 'se-resize';
            // 阻止默认行为（如选中文本）
            e.preventDefault();
        },
        // 新增：鼠标移动时调整宽高
        handleMouseMove(e) {
            if (!this.resizingComponent) return;

            // 计算鼠标移动的偏移量
            const deltaX = e.clientX - this.startX;
            const deltaY = e.clientY - this.startY;

            // 计算新的宽高（限制最小值和最大值）
            const newWidth = Math.max(200, Math.min(1200, this.startWidth + deltaX));
            const newHeight = Math.max(200, Math.min(800, this.startHeight + deltaY));

            // 更新组件宽高（响应式更新视图）
            this.resizingComponent.width = newWidth;
            this.resizingComponent.height = newHeight;
        },
        // 新增：停止拖拽并同步到后端
        stopResize() {
            if (this.resizingComponent) {
                // 恢复鼠标样式
                document.body.style.cursor = 'default';

                // 同步修改到后端（如果组件有ID，说明是已保存的组件）
                if (this.resizingComponent.id) {
                    this.syncResizeToBackend(this.resizingComponent);
                }

                // 重置拖拽状态
                this.resizingComponent = null;
                this.startX = 0;
                this.startY = 0;
                this.startWidth = 0;
                this.startHeight = 0;
            }
        },
        // 新增：将拖拽调整后的宽高同步到后端
        async syncResizeToBackend(component) {
            const editData = {
                id: component.id,
                name: component.name,
                path: this.componentPathMap[component.name] || component.path,
                width: component.width,
                height: component.height,
                userId: localStorage.getItem('userId')
            };

            try {
                await editHomePageModels(editData);
                console.log('组件宽高同步成功：', component.id);
            } catch (error) {
                console.error('组件宽高同步失败：', error);
                this.$message.warning('组件尺寸修改已生效，但未同步到服务器，请手动保存');
            }
        },

        // 核心修改：转换后端数据格式，补充props和events
        getList() {
            getHomePageModels({ userId: localStorage.getItem('userId') }).then(response => {
                console.log('后端返回数据：', response);
                if (Array.isArray(response.data)) {
                    // 遍历后端数据，转换格式并补充props/events
                    this.activeComponents = response.data.map(item => {
                        // 转换width/height为数值类型（后端返回的是字符串）
                        const width = Number(item.width) || 400;
                        const height = Number(item.height) || 400;

                        // 根据组件名称获取对应的props和events
                        const { props, events } = this.getComponentPropsAndEvents(item.name);

                        return {
                            ...item, // 保留后端返回的所有字段
                            width,   // 覆盖为数值类型
                            height,  // 覆盖为数值类型
                            props,   // 补充组件属性
                            events   // 补充组件事件
                        };
                    });
                }
            }).catch(error => {
                console.error('获取组件列表失败：', error);
                this.$message.error('加载组件配置失败，请刷新重试');
            });
        },

        // 新增：根据组件名称获取对应的props和events
        getComponentPropsAndEvents(componentName) {
            let props = {};
            let events = {};

            switch (componentName) {
                case 'CheckinOverview':
                    props = { checkinList: this.checkinOverviewList };
                    events = { 'preview-image': this.handlePreviewImage };
                    break;
                case 'DeviceStatusChart':
                    props = { chartData: this.deviceChartData };
                    break;
                case 'CheckinStatusChart':
                    props = { chartData: this.checkinChartData };
                    break;
                case 'DeviceManagement':
                    props = { deviceList: this.deviceList, roomList: this.roomList };
                    events = { 'check-expired': this.handleCheckExpired };
                    break;
                case 'TodayMenu':
                    props = { menuList: this.todayMenuList };
                    break;
                // 其他组件默认空props/events
                default:
                    break;
            }

            return { props, events };
        },

        // 合并：打开新增/编辑弹窗
        openComponentModal(type, item = null) {
            this.modalType = type;
            this.componentModalVisible = true;

            // 重置表单
            this.resetComponentForm();

            if (type === 'edit' && item) {
                // 编辑模式：回显数据
                this.editComponentId = item.id;
                this.componentForm = {
                    componentName: item.name,
                    width: item.width || 400,
                    height: item.height || 400
                };
            } else {
                // 新增模式：默认值
                this.editComponentId = '';
                this.componentForm = {
                    componentName: '',
                    width: 400,
                    height: 400
                };
            }
        },

        // 合并：提交新增/编辑表单
        async submitComponentForm() {
            // 先校验表单
            try {
                await this.$refs.componentFormRef.validate();
            } catch (error) {
                this.$message.warning('请完善表单信息');
                return;
            }

            if (this.modalType === 'add') {
                // 新增逻辑
                await this.addComponent();
            } else {
                // 编辑逻辑：支持修改name/path/width/height
                await this.editComponent();
            }
        },

        // 新增组件
        async addComponent() {
            const submitData = {
                name: this.componentForm.componentName,
                path: this.componentPathMap[this.componentForm.componentName],
                width: this.componentForm.width,
                height: this.componentForm.height,
                userId: localStorage.getItem('userId')
            };

            try {
                const res = await addHomePageModels(submitData);
                if (res.code === 200 || res.success) {
                    this.$message.success('组件添加成功');
                    this.componentModalVisible = false;
                    this.resetComponentForm();
                    this.getList(); // 刷新列表
                } else {
                    this.$message.error('添加失败：' + (res.msg || '未知错误'));
                }
            } catch (error) {
                console.error('添加组件出错：', error);
                this.$message.error('添加组件时发生错误，请重试');
            }
        },

        // 编辑组件：核心修改-支持修改name/path/width/height
        async editComponent() {
            if (!this.editComponentId) {
                this.$message.warning('编辑的组件ID不存在');
                return;
            }

            // 构造编辑接口参数：包含name/path/width/height
            const editData = {
                id: this.editComponentId,
                name: this.componentForm.componentName,
                path: this.componentPathMap[this.componentForm.componentName],
                width: this.componentForm.width,
                height: this.componentForm.height,
                userId: localStorage.getItem('userId')
            };

            try {
                // 调用修改接口 editHomePageModels
                const res = await editHomePageModels(editData);
                if (res.code === 200 || res.success) {
                    this.$message.success('组件修改成功');
                    this.componentModalVisible = false;
                    this.resetComponentForm();
                    this.getList(); // 刷新列表
                } else {
                    this.$message.error('修改失败：' + (res.msg || '未知错误'));
                }
            } catch (error) {
                console.error('编辑组件出错：', error);
                this.$message.error('修改组件时发生错误，请重试');
            }
        },

        // 重置表单（新增/编辑共用）
        resetComponentForm() {
            this.editComponentId = '';
            this.componentForm = {
                componentName: '',
                width: 400,
                height: 400
            };
            // 重置表单校验状态
            if (this.$refs.componentFormRef) {
                this.$refs.componentFormRef.resetFields();
            }
        },

        // 删除组件的确认逻辑
        handledeleteHomePageModels(componentId) {
            this.$confirm('确定要删除该组件吗？删除后无法恢复', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                // 确认删除，调用删除接口
                const deleteSuccess = await this.deleteHomePageModels(componentId);
                if (deleteSuccess) {
                    this.$message.success('组件删除成功');
                    // 刷新组件列表
                    this.getList();
                }
            }).catch(() => {
                this.$message.info('已取消删除');
            });
        },

        // 调用后端删除接口
        async deleteHomePageModels(componentId) {
            try {
                // 调用后端删除接口，传入组件ID
                const res = await deleteHomePageModels({ id: componentId });
                if (res.code === 200 || res.success) {
                    return true;
                } else {
                    this.$message.error('删除失败：' + (res.msg || '未知错误'));
                    return false;
                }
            } catch (error) {
                console.error('删除组件出错：', error);
                this.$message.error('删除组件时发生错误，请重试');
                return false;
            }
        },

        // 统一获取所有数据
        fetchAllData() {
            this.getCheckinList();
            this.getDeviceStatusForChart();
            this.getCheckinStatusForChart();
            this.loadRoomList();
            this.loadDevices();
        },

        // --- 数据获取方法 ---
        getCheckinList() {
            getCheckData({ userId: localStorage.getItem('userId') }).then(response => {
                const resData = response.data || [];
                this.checkinOverviewList = resData.map(item => ({
                    faceUrl: item.faceFileUrl,
                    checkTime: item.checkTime,
                    realName: item.realName,
                    abnormalTemp: item.abnormalTemp
                }));
            }).catch(() => {
                this.checkinOverviewList = [];
            });
        },

        getDeviceStatusForChart() {
            getDevices().then(response => {
                const rawData = response.data || [];
                const statusCount = rawData.reduce((acc, item) => {
                    acc[item.deviceStatus === '1' ? 'online' : 'offline']++;
                    return acc;
                }, { online: 0, offline: 0 });

                this.deviceChartData = [
                    { value: statusCount.online, name: '在线' },
                    { value: statusCount.offline, name: '离线' }
                ];
            }).catch(() => {
                this.deviceChartData = [{ value: 0, name: '在线' }, { value: 0, name: '离线' }];
            });
        },

        getCheckinStatusForChart() {
            getClockIn().then(response => {
                const rawData = response.data || [];
                const checkedIn = rawData.filter(item => item.checkTime).length;
                const notCheckedIn = rawData.length - checkedIn;

                this.checkinChartData = [
                    { value: checkedIn, name: '已打卡' },
                    { value: notCheckedIn, name: '未打卡' }
                ];
            }).catch(() => {
                this.checkinChartData = [{ value: 0, name: '已打卡' }, { value: 0, name: '未打卡' }];
            });
        },

        async loadRoomList() {
            try {
                const res = await getRoomList({ userId: localStorage.getItem('userId') });
                this.roomList = res.data || [];
            } catch (error) {
                this.$message.error('加载功能间列表失败');
            }
        },

        async loadDevices() {
            try {
                const res = await getDeviceList({ userId: localStorage.getItem('userId') });
                this.deviceList = res.data || [];
                // 检查过期维保设备
                this.checkExpiredMaintenanceDevice();
            } catch (error) {
                this.$message.error('加载设备列表异常');
                this.deviceList = [];
            }
        },

        // --- 事件处理方法 ---
        handlePreviewImage(url, title) {
            this.previewImageUrl = url;
            this.previewTitle = title;
            this.previewVisible = true;
        },

        handleCheckExpired(expiredList) {
            this.expiredDeviceList = expiredList;
            if (expiredList.length > 0 && !this.hasWarned) {
                this.maintenanceWarnVisible = true;
                this.hasWarned = true;
            }
        },

        handleGotoMaintenance() {
            this.$router.push("/deviceList");
            this.maintenanceWarnVisible = false;
        },

        checkExpiredMaintenanceDevice() {
            if (!this.deviceList.length || this.hasWarned) return;
            const now = new Date().getTime();
            this.expiredDeviceList = this.deviceList.filter(item => {
                if (!item.nextMaintenance) return false;
                try {
                    return new Date(item.nextMaintenance).getTime() < now;
                } catch (error) {
                    return false;
                }
            });
            if (this.expiredDeviceList.length > 0) {
                this.maintenanceWarnVisible = true;
                this.hasWarned = true;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
// 核心修复：给容器固定高度，确保 overflow 生效
.dashboard-container {
    height: 100vh;
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
    position: relative;
    z-index: 1;
}

// 新增：添加组件按钮样式
.add-component-btn {
    margin-bottom: 20px;
}

.main-content {
    width: 100%;
    height: calc(100vh - 15vh);
    overflow: auto;
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    background-color: #f5f5f5;
    padding: 16px;
    border-radius: 8px;
    z-index: 1;
    position: relative;
    align-content: flex-start
}

// 组件卡片样式
.component-card {
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
    // padding: 16px;
    box-sizing: border-box;
    overflow: hidden;
    // 新增：开启定位上下文，让拖拽手柄定位生效
    position: relative;
}

// 操作按钮组样式
.component-actions {
    position: absolute;
    top: 8px;
    right: 8px;
    opacity: 0;
    transition: opacity 0.3s;
    background: rgba(255, 255, 255, 0.8);
    padding: 4px;
    border-radius: 4px;
    display: flex;
    gap: 8px;
    z-index: 10;
}

.component-card:hover .component-actions {
    opacity: 1;
}

// 新增：拖拽调整手柄样式
.resize-handle {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 20px;
    height: 20px;
    background-color: #409eff;
    border-top-left-radius: 8px;
    cursor: se-resize;

    // 悬浮效果
    &:hover {
        background-color: #66b1ff;
    }

    // 确保在操作按钮下方但可点击
    z-index: 5;
}

// 全局样式：提升所有弹窗的默认层级
::v-deep .el-dialog {
    z-index: 2000 !important;
}

::v-deep .el-dialog__wrapper {
    z-index: 2000 !important;
}

// 合并：组件弹窗样式强化
::v-deep .component-modal-dialog {
    .el-dialog__body {
        padding: 20px;
        height: 220px;
        /* 固定内容区高度 */
        overflow-y: auto;
        /* 超出滚动 */
        box-sizing: border-box;
    }

    .el-dialog__header {
        padding: 15px 20px;
        border-bottom: 1px solid #e6e6e6;
    }

    .el-dialog__footer {
        padding: 15px 20px;
        border-top: 1px solid #e6e6e6;
        text-align: right;
    }
}
</style>